import { useAnalytics } from "adapters/analytics";
import {
  getEmailFromStorage,
  getSelectedFarmStateFromStorage,
} from "shared/storageUtils";

type UseHerdControlAnalyticsProps = {
  tabName: string;
};

/**
 * Custom hook for tracking analytics events related to herd control tabs.
 *
 * @remarks
 * The `trackEvent` function collects user email and selected farm information from storage,
 * formats an action description, and sends an analytics event with the provided tab name as
 * the category and label.
 */
export function useHerdControlAnalytics({
  tabName,
}: UseHerdControlAnalyticsProps) {
  const analytics = useAnalytics();

  const trackEvent = () => {
    const userEmail = getEmailFromStorage();
    const emailParts = userEmail?.split("@") ?? [];
    const selectedFarm = getSelectedFarmStateFromStorage();

    const action = `Acesso ${tabName}:
      inicio do email do usuário: ${emailParts[0] ?? ""}
      final do email do usuário: ${emailParts[1] ?? ""}
      Fazenda: ${selectedFarm?.Nome ?? ""}
      IdFazenda: ${selectedFarm?.IdFazenda ?? ""}`;

    analytics.trackEvent({ action, category: tabName, label: tabName });
  };

  return { trackEvent };
}
